import React from 'react'
import {Link} from 'react-router-dom';
import { Menu, Dropdown, Image, Responsive } from 'semantic-ui-react'
import Logo from '../../logo.png';
import Search from './Search';
import PushMenu from './PushMenu';
import CustomDropdown from '../Dropdown';

const MenuItem = isDesktopMenu => {
	const MenuItemRecur = props => {
		const { ID, title, url, originalUrl, childrenMenus = [], menu_item_parent } = props;
		const active = window.location.pathname.indexOf(url) >= 0;

		const LinkComponent = originalUrl.startsWith(window.location.origin) || originalUrl.startsWith('http://localhost:8888') ? Link : 'a';

		if (isDesktopMenu) {
			if (childrenMenus.length) {
				return (
					<CustomDropdown title={title} items={childrenMenus} />
				);
			} else {
				const MenuItemComponent = menu_item_parent == '0' ? Menu.Item : Dropdown.Item;
				return (
					<MenuItemComponent
						name={title}
						as={LinkComponent}
						to={url}
						href={originalUrl}
						active={active}
						className={menu_item_parent == '0' ? 'standard-header' : 'inset-text-header'}
						key={ID}
					>
						<span dangerouslySetInnerHTML={{__html: title}}/>
					</MenuItemComponent>
				);
			}
		} else {
			if (childrenMenus.length) {
				return (
					<Menu.Item key={ID}>
						{menu_item_parent == '0' && <Menu.Header className='standard-header'
									 dangerouslySetInnerHTML={{__html: title}}/>}
						{menu_item_parent != '0' && <Menu.Header
							as={LinkComponent}
							to={url}
							className='standard-header'
							dangerouslySetInnerHTML={{__html: title}}/>}

						<Menu.Menu vertical secondary>
							{childrenMenus.map((child) => <MenuItemRecur key={child.ID} {...child} />)}
						</Menu.Menu>
					</Menu.Item>
				);
			} else {
				return (
					<Menu.Item
						name={title}
						as={LinkComponent}
						to={url}
						href={originalUrl}
						active={active}
						className='standard-header'
						key={ID}
					/>
				);
			}
		}
	};
	return MenuItemRecur;
};

export default props => {
	const { menuContent, children } = props;

	if (window.innerWidth > Responsive.onlyMobile.maxWidth) {
		return (
			<div id="mainMenu">
				<Menu stackable inverted attached className='menu-border-bottom'>
					<Menu.Item as={Link} to='/' active={window.location.pathname==='/'} className='standard-header'>
						<Image src={Logo} style={{width: '2em', display: 'inline', paddingRight: '1em'}}/> Home
					</Menu.Item>
					{menuContent.map(MenuItem(true))}
					{/*<Menu.Menu position='right'>*/}
						{/*<Responsive {...Responsive.onlyComputer}>*/}
							{/*<Search />*/}
						{/*</Responsive>*/}
					{/*</Menu.Menu>*/}
				</Menu>
				{children}
			</div>
		);
	} else {
		return (
			<PushMenu pageContent={children}>
				<Menu.Item as={Link} to='/' active={window.location.pathname==='/'} className='standard-header'>
					<Image src={Logo} style={{width: '2em', display: 'inline', paddingRight: '1em'}}/> Home
				</Menu.Item>
				{menuContent.map(MenuItem(false))}
				{/*<Menu.Menu position='right'>*/}
					{/*<Responsive {...Responsive.onlyComputer}>*/}
						{/*<Search />*/}
					{/*</Responsive>*/}
				{/*</Menu.Menu>*/}
			</PushMenu>
		);
	}
}



// WEBPACK FOOTER //
// ./src/modules/Menu/Menu.js